
import React from "react";
import { Badge } from "react-bootstrap";
import alarm from "../img/ico-alarm-ep.svg";

export default class AssignmentListItem extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      buttonClass: "",
      urgentMobile: ""
    }
  }

  componentDidMount = () => {

    // this is used to give the correct class to the buttons
    let buttonClass;
    switch (this.props.data.startbuttonstatus) {
      case 1:
      case 3:
        buttonClass = "success";
        break;
      case 2:
      case 5:
        buttonClass = "primary";
        break;
      default:
        buttonClass =  "";
    }
    let urgentMobile;
    this.props.data.urgent ? urgentMobile = "mobile-list-urgent" : urgentMobile = ""

      this.setState({
        buttonClass: buttonClass,
        urgentMobile})
        
  }

  getStartButtonUrl = () => {

    if(this.props.data.startbuttonstatus == 4) {
      return null;
    }
    if(this.props.data.startbuttonstatus == 5) {
     return "/osa/script.php?a=" + this.props.data.assignmentkey;
    }

    return "/osa/a=" + this.props.data.assignmentkey; 
  }


  render() {
    const { data } = this.props;
            return (

              this.props.data ?
                <li className= "col-md-12 assignment-block list-view">
                  <div className= "AssignmentListItem row list-view">
                    {data.isnew ?
                    <Badge pill bg="danger" className="badge-new">
                      New!
                    </Badge>
                     : null }
                    <div className="col-md-4 assignment-title-wrap">
                      <div className={`assignment-title row`}>
                        <div className={`subject-icons circle-${data.docsubject}`}>
                          <i className={`subject-icon ${data.docsubject}`}/>
                        </div>
                        <div className="title-assesstitle">
                          <h2>{data.title}</h2>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className={`assignment-time row`}>
                       {data.urgent ?
                        <div className="col-sm-2 clock-container">
                          <img alt="alarm-clock" className="alarm-clock" src={alarm}/>
                        </div>
                        : null}

                        <div className="col-sm-10">
                          <p>{data.urgent ? <i className="fa fa-clock mobile-list-clock" />
                            : null}<span className={this.state.urgentMobile}>{data.timetext}</span></p>
                          <p><strong>{data.fixedduration ? "Time allowed" : "Time suggested"}</strong>: {data.duration} mins</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 assignment-action-buttons">
   
                    {data.startbuttonstatus !== 4 ? 
                      <a href={data.startbuttonurl} 
	                      className={`btn btn-${this.state.buttonClass}`} role="button" 
                        target={this.state.buttonClass}>{data.startbuttontext}</a>
                    : ''}  

                    </div>
                    <div className={`col-md-2 assignment-status ${data.status}`}>
                      <p className={`${data.status}`}>{data.status}</p>
                    </div>
                  </div>
                </li>
                : <p className="noAssignments">You have no assignments to complete yet. Speak to your teacher or come back later.</p>

           )
   }
}
